<template>
  <div>
    <div class="m-header">
      <router-link
        to="/"
        @click.native="flushCom"
      >
        <img
          class="m-logo"
          src="@assets/images/logo1.png"
        >
      </router-link>

      <router-link
        to="/search"
        class="m-search-btn"
      />
    </div>
    <div class="m-list-title">
      {{ title }}
    </div>
    <div class="m-content">
      <a-list
        v-if="okrList.length>0"
        item-layout="horizontal"
        :data-source="okrList"
        :pagination="false"
      >
        <a-list-item
          slot="renderItem"
          slot-scope="record"
        >
          <a
            v-if="record.id"
            class="m-list-item active"
            @click="() => handleClickView(record.id)"
          >
            <span class="m-list-item-title">{{ record.title }}</span>
            <span class="m-list-item-time">{{ record.time }}</span>
          </a>
          <div
            v-else
            class="m-list-item"
          >
            <span class="m-list-item-title">{{ record.title }}</span>
            <span class="m-list-item-time">{{ record.time }}</span>
          </div>
        </a-list-item>
      </a-list>
      <div
        v-if="emptyList"
        class="list-content-empty"
      >
        <img src="@assets/images/empty.png">
        <div>咦 ~ 真的什么都没有耶…</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Table, Button, List, message } from 'ant-design-vue'
import { setDDTitle } from '@utils'

Vue.use(Table)
Vue.use(Button)
Vue.use(List)

export default {
  name: 'OkrList',
  data() {
    return {
      userId: null,
      okrList: [],
      emptyList: false,
      title: '',
    }
  },
  computed: {
    ...mapState({
      currentTime: state => state.serverTime,
      currentUser: state => state.userId,
    }),
  },
  beforeCreate() {
    setDDTitle('校宝绩效管理平台')
    document.title = '校宝绩效管理平台'
  },
  async created() {
    const userId = this.$route.params.userId
    this.userId = userId
    try {
      await this.$store.dispatch('getServerTime')
      await this.fetchOkrList()
      const title = this.userId ? `${this.listUser}的目标` : '我的目标'
      this.title = title
    } catch (error) {
      const msg = error.errorMessage || error.message || '网络错误'
      message.error(msg)
    }
  },
  methods: {
    /**
     * 获取 OKR 列表
     */
    async fetchOkrList() {
      const value = this.userId || ''
      const currentYear = this.currentTime.year
      const currentQuarter = this.currentTime.quarter
      let createNew = false
      let txt
      const result = await this.$api.okr.getList({
        userId: value,
      })
      this.listUser = result.userName
      result.quarterInfoDtoList.forEach((okr) => {
        if (!okr.id && okr.year === currentYear && okr.quarter === currentQuarter && !this.userId) {
          createNew = true
        }
        // 过滤年度数据
        if (okr.id && okr.quarter !== 0) {
          txt = okr.updateTime
          const word = `${okr.year}年Q${okr.quarter}季度业绩目标`
          this.okrList.push({ id: okr.id, title: word, time: txt })
        }
      })
      if (createNew) {
        const word = `${currentYear}年Q${currentQuarter}季度业绩目标`
        txt = '业绩目标未创建，请去PC端编辑或上传'
        // 插入一条新的记录到数组最上面
        this.okrList.unshift({ title: word, time: txt })
      }
      // 如果没有数据，显示无结果的页面
      if (!this.okrList.length) {
        this.emptyList = true
      }
    },
    // 点击查看按钮，新开页面进入详情页面
    handleClickView (id) {
      this.$router.push({
        name: 'OKRDetail',
        params: { okrId: id },
      })
    },
    // 强制页面刷新，辅助点击logo返回myokr列表页
    flushCom() {
      // router.go(n)是路由的一个方法，意思是在history记录中前进或者后退多少步，0就表示还是当前，类似window.history.go(n)
      this.$router.go(0)
    },

  },
}
</script>

<style lang="less">
.m-header{height: .5rem; display: flex; justify-content: space-between; align-items:center; padding: 0 .2rem; background-color: #fff;}
.m-logo{height: .21rem;}
.m-search-btn{display:block; width:.24rem; height: .24rem; background: url('~@images/mIco-search1.png') no-repeat; background-size: 100% 100%; border: none;}
.m-list-title{height: .5rem; line-height: .5rem; font-size:.18rem; padding-left: .2rem; font-size:.14rem; font-weight: bold;}
.list-content-loading,.list-content-empty{display: flex; flex-direction: column; align-items:center; justify-content: center; height: 2.4rem;
font-size:.14rem; color:#888; background-color: #fff;}
.list-content-loading img { height: 1.2rem; margin-bottom: .1rem;}
.list-content-empty img { height: 1.1rem; margin-bottom: .1rem;}
.m-content{ background-color: #fff;}
.m-list-item{height: .68rem; width:100%; position: relative; display: flex; flex-direction: column; justify-content: center;
 background: url('~@images/mIco-list.png') no-repeat .18rem center; background-size: .24rem auto; padding-left: .52rem;
  &.active::after{content:""; position: absolute; right:.25rem; top:50%; margin-top:-.12rem; width:.08rem; height: .16rem;
  background: url('~@images/mIco-listitem.png') no-repeat; background-size: 100% 100%;}
}
.m-list-item-title{ font-size: .16rem; font-weight: bold; color:#000;}
.m-list-item-time{ font-size:.12rem; color:#999;}
</style>
